interface AddressLine {
  street: string;
  house_number: string;
  postal_code: string;
  city: string;
}

interface NamedAddressLine extends AddressLine {
  name: string;
}

export function formatAddressLine(address: AddressLine): string {
  return `${address.street} ${address.house_number}, ${address.postal_code} ${address.city}`;
}

export function formatAddressWithName(address: NamedAddressLine): string {
  return `${address.name} - ${formatAddressLine(address)}`;
}
